import { createSelector } from '@ngrx/store';
import { selectAllFlightFollowingReports } from './entity-store-selectors';

export function selectFlightFollowingReportById(id: string) {
  return createSelector(selectAllFlightFollowingReports, (reports) => {
    return reports.valueSeq().find((r) => r.id === id);
  });
}

export function selectFlightFollowingReportsByTripId(tripId: string) {
  return createSelector(selectAllFlightFollowingReports, (reports) => {
    return reports.filter((r) => r.tripId === tripId);
  });
}

export function selectFlightFollowingReportsByTripLegId(tripLegId: string) {
  return createSelector(selectAllFlightFollowingReports, (reports) => {
    return reports.find((r) => r.tripLegId === tripLegId);
  });
}
